module.exports = __webpack_public_path__ + "static/media/adaptivenn.fd5c9f44.png";